import { Link, useLocation, useNavigate } from "react-router-dom";
import { DeleteIcon, EllipsisVertical, Upload } from "lucide-react";
import { ListFilter, Search } from "lucide-react";
import { Badge } from "../../component/ui/badge";
import { Button } from "../../component/ui/button";
import { BsUpload } from "react-icons/bs";
import { FaRegEye } from "react-icons/fa";
import { CiEdit } from "react-icons/ci";
import { IoIosAdd } from "react-icons/io";

import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../component/ui/dropdown-menu";
import { Input } from "../../component/ui/input";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../component/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../component/table/table";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../component/ui/tabs";
import SchemeTable
  from "../../component/scheme/SchemeTable";
import { useEffect, useState } from "react";
import NewSchemaForm from "../../component/scheme/NewSchemaForm";
import { SchemeView } from "../../component/scheme/SchemeView";
import { deleteScheme, getAllSchemeDetails, getSchemeInfo } from "../../utils/util";
import { MdDelete } from "react-icons/md";
import { useDispatch } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";
import { setSchemeInfo } from "../../context/actions/schemeInfoAction";
import { alertDanger, alertSuccess } from "../../context/actions/toastAction";
import Loader from "../../component/loader";
function Schemes({employee}) {
  const navigate=useNavigate()
  const location = useLocation(); 
  const [schemeData,setSChemeData]=useState([])
const dispatch=useDispatch()
const [currentPage,setCurrentPage]=useState(1)
const [totalPage,setTotalPage]=useState(1)
const [isLoading,setIsLoading]=useState(false)
  const schemeListData = [
    {
      schemeName: "Vasuki India Fund",
      className: "A",
      tickerMessage: "Random Custom Ticker Message",
    },
    {
      schemeName: "Vasuki XVI",
      className: "B",
      tickerMessage: "N/A",
    },

  ];

  const [isCreateNewScheme, setIsCreateNewScheme] = useState(false)

  
  const columns = [
    { id: 'scheme_name', header: 'Name' },
    { id: 'scheme_class', header: 'Class' },

  ];


  const getAllScheme=async()=>{
    setIsLoading(true)
    const payload ={
      page_no : currentPage,
       per_page : 10
    }
    try {
      const response=await getAllSchemeDetails(payload)
    console.log("response for scheme details",response)
    if(response){
      setSChemeData(response?.data.data)
      setTotalPage(response.data.totalPages)
      setIsLoading(false)
    }
    else{
      setIsLoading(false)
    }
    } catch (error) {
      console.log("error in get all scheme details api",error)
      setIsLoading(false)
    } 
    // finally {
    //   setTimeout(() => dispatch(loaderSet(false)), 1000); // Adds a slight delay
    // }
    
  }


  const handleDeleteSchemes=async(...data)=>{
    setIsLoading(true)
    const payload={
      scheme_id: data[0].scheme_id,
      scheme_name: data[0].scheme_name,
      scheme_class: data[0].scheme_class,

    }
    try {
      const response=await deleteScheme(payload)
      if(response && response.code===200){
        
        getAllScheme()
        dispatch(alertSuccess("Deleted the scheme"))
        setIsLoading(false)
      }
      else{
        dispatch(alertDanger(response?.message))
        setIsLoading(false)
      }
    } catch (error) {
      dispatch(alertDanger("Internal Server Error"))
      console.log("Error in delete scheme ",error)
      setIsLoading(false)
    }
  }


  const handleSchemeView=async(...data)=>{
    setIsLoading(true)
    const payload={
      scheme_id: data[0].scheme_id,
      scheme_name: data[0].scheme_name,
      scheme_class: data[0].scheme_class,
    }
    try {
      const response=await getSchemeInfo(payload)
      console.log("response for scheme info view",response?.data)
      if (response && response?.code===200){
        dispatch(setSchemeInfo(response?.data))
        
        navigate( !employee ? `/admin/scheme-view?scheme_id=${payload.scheme_id}&action_type=${"View"}`: `/employee/scheme-view?scheme_id=${payload.scheme_id}&action_type=${"View"}` )
        setIsLoading(false)
        return
      }
      else{
        dispatch(alertDanger(response?.message))
        setIsLoading(false)
      }

    } catch (error) {
      console.log("Error in scheme view",error)
      dispatch(alertDanger("Internal Server Error"))
      setIsLoading(false)
    }
  }

  const handleSchemeEdit=async(...data)=>{
    setIsLoading(true)
    const payload={
      scheme_id: data[0].scheme_id,
      scheme_name: data[0].scheme_name,
      scheme_class: data[0].scheme_class,
    }
    try {
      const response=await getSchemeInfo(payload)
      console.log("response for scheme info view",response?.data)
      if (response && response?.code===200 ){
        dispatch(setSchemeInfo(response?.data))
        navigate( !employee ? `/admin/scheme-edit?scheme_id=${payload.scheme_id}&action_type=${"Edit"}`: `/employee/scheme-edit?scheme_id=${payload.scheme_id}&action_type=${"Edit"}` )
        // dispatch(loaderSet(false))
        setIsLoading(false)
        return
      }
      else{
        dispatch(alertDanger(response?.message))
        setIsLoading(false)
      }

    } catch (error) {
      console.log("Error in scheme Edit",error)
      dispatch(alertDanger("Internal Server Error"))
      setIsLoading(false)
    }
  }

  const buttonOptions = [
    {
      icon: <CiEdit />,
      alt: "",
      text: <span className="text-base font-semibold">Edit</span>,
      iconHeight: 17,
      iconWidth: 17,
      iconColor: "black",
      name: "Edit",
      actionHandleEditScheme:handleSchemeEdit
    },
    
    {
      icon: <FaRegEye />,
      alt: "",
      text: <span className="text-base font-semibold">View</span>,
      iconHeight: 17,
      iconWidth: 17,
      iconColor: "black",
      name: "View",
      actionHandleViewScheme: handleSchemeView
    },
   !employee && {
      icon: <MdDelete />,
      alt: "",
      text: <span className="text-base font-semibold">Delete</span>,
      iconHeight: 17,
      iconWidth: 17,
      iconColor: "black",
      name: "Delete",
      actionHandleDeleteScheme: handleDeleteSchemes
    },
  ].filter(Boolean)
useEffect(()=>{
getAllScheme()
if(schemeData.length>0){
  console.log("Scheme Data",schemeData)
}
},[currentPage])
  // return (
  //   <>
  //   {
  //       isLoading && <Loader/>
  //     }
  //   (isCreateNewScheme || (!employee ? location.pathname === "/admin/scheme-edit" : location.pathname === "/employee/scheme-edit" ))  ?
  //     <NewSchemaForm forWhichUserType={ employee ? "employee" : "admin"} back={()=>setIsCreateNewScheme(false)} getAllScheme={getAllScheme} />
  //     : (!employee ? location.pathname === "/admin/scheme-view" : location.pathname === "/employee/scheme-view" ) ? 
  //       <SchemeView forWhichUserType={ employee ? "employee" : "admin"} back={()=>setIsCreateNewScheme(false)} /> :
  //     <SchemeTable totalPage={totalPage} currentPage={currentPage} setCurrentPage={setCurrentPage} buttonOptions={buttonOptions} columns={columns} schemeListData={schemeData} showNewSchemaForm={() => setIsCreateNewScheme(true)} />
  //   </>


  // );


  return (
    <>
      {/* accessiblity fix for silktide issues - H1 heading */}
      <h1 className="sr-only">Schemes</h1>
      {isLoading && <Loader />}
      {isCreateNewScheme || 
      (!employee 
        ? location.pathname === "/admin/scheme-edit" 
        : location.pathname === "/employee/scheme-edit")
        ? (
          <NewSchemaForm
            forWhichUserType={employee ? "employee" : "admin"}
            back={() => setIsCreateNewScheme(false)}
            getAllScheme={getAllScheme}
          />
        ) : 
        (!employee 
          ? location.pathname === "/admin/scheme-view" 
          : location.pathname === "/employee/scheme-view")
          ? (
            <SchemeView
              forWhichUserType={employee ? "employee" : "admin"}
              back={() => setIsCreateNewScheme(false)}
            />
          ) : (
            <SchemeTable
              totalPage={totalPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              buttonOptions={buttonOptions}
              columns={columns}
              schemeListData={schemeData}
              showNewSchemaForm={() => setIsCreateNewScheme(true)}
            />
          )}
    </>
  );
  

}

export default Schemes;
